import { Button, Heading, Text } from '@radix-ui/themes';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from './AuthProvider.tsx';

/** Shown when the session is valid but the account lacks the role required to use the app. */
export function NoAccessPage() {
  const { logout } = useAuth();
  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center"
      aria-labelledby="no-access-title"
    >
      <ShieldAlert size={40} className="text-[var(--accent-9)]" aria-hidden="true" />
      <Heading id="no-access-title" size="5">
        No access to Ops Desk
      </Heading>
      <Text color="gray" size="2" className="max-w-md">
        You are signed in, but your account does not have the operations role that Ops Desk
        requires. Ask an administrator for access, or sign in with a different account.
      </Text>
      <Button mt="2" onClick={() => void logout()}>
        Sign out
      </Button>
    </main>
  );
}
